@file:Suppress("UNCHECKED_CAST_TO_EXTERNAL_INTERFACE")

package org.example.project.enginecardview

import androidx.compose.runtime.*
import org.example.project.enginetabular.TableStyles
import org.example.project.settings.AppDropdown
import org.example.project.utils.All
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

private val CARD_ACTION_WIDTH = 150.px

@Composable
internal fun CardViewDropdown(
    label: String,
    options: List<String>,
    width: CSSSizeValue<CSSUnit.px>,
    selectedValue: String,
    enabled: Boolean = true,
    onChange: (String) -> Unit
) {
    Div({ style { this.width(width) } }) {
        AppDropdown(
            options = buildList {
                add(All(key = "", label = label))
                addAll(options.map { All(key = it, label = it) })
            },
            selectedValue = selectedValue,
            enabled = enabled,
            onChange = onChange,
            attrs = { classes(TableStyles.button) }
        )
    }
    CardViewDivider()
}

@Composable
internal fun CardViewActionButton(label: String, icon: String, onClick: () -> Unit) {
    Button(attrs = {
        classes(TableStyles.topBarButton)
        onClick { onClick() }
        style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            gap(8.px)
            width(CARD_ACTION_WIDTH)
            justifyContent(JustifyContent.Center)
        }
    }) {
        Img(src = icon, attrs = { classes(TableStyles.topBarIcon) })
        Span({ style { whiteSpace("nowrap") } }) { Text(label) }
    }
    CardViewDivider()
}

@Composable
internal fun CardViewDivider() {
    Div({ classes(TableStyles.quickDivider) })
}
